import React, {useEffect} from 'react';
import axios, {AxiosRequestConfig, InternalAxiosRequestConfig} from "axios";
import {useIntl} from 'react-intl';
import {useToast} from "./hooks/useToast";
import {usePreloader} from "./hooks/usePreloader";
import {apiConfig} from "./api-config";
import {useUserInfo} from "./hooks/useUserInfo";

interface Props {
    callback: () => void;
    children: React.ReactNode
}

export const AxiosInterceptor : React.FC<Props> = props => {
    const {showToast} = useToast();
    const {updateUserInfo} = useUserInfo();
    const {formatMessage: f} = useIntl();
    const { setLoading } = usePreloader();

    //!IMPORTANT This function should stay in the useEffect so onComponentDidUnmount the interceptor is being ejected and the replaced with new one!
    useEffect(() => {
        const authInterceptor = axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
            const isSWRRequest = config.data && config.data.isSWR;
            if(!isSWRRequest)
                setLoading(true);
            config.baseURL = apiConfig.API_URL;
            config.withCredentials = true;
            // setLoading(true);
            return config
        });

        // axios.get('/kc/me',).then(res => {
        //     setData(res.data.username, res.data.userRole, res.data.darkMode);
        //     props.callback();
        // });
        props.callback();

        return () => {
            axios.interceptors.request.eject(authInterceptor);
        }

    }, []);

    useEffect(() => {
        const responseInterceptor = axios.interceptors.response.use((response) => {
            // if((response.headers['content-type']) === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') toast.clearToast();
            if (response.data.message) {
                showToast("success", f({id: "operationSuccessful"}), f({id: response.data.message}));
            } else if (response.data.indexOf !== undefined && response.data.indexOf('ok') === 0 && response.data.indexOf('message') !== -1) {
                const data = JSON.parse(response.data.substr(response.data.indexOf('{'), response.data.length));
                showToast("success", f({id: "operationSuccessful"}), f({id: data.message}));
            }
            const isSWRRequest = response.config.data && response.config.data.isSWR;
            if (!isSWRRequest)
                setLoading(false);

            return response;
        }, (err) => {
            setLoading(false);
            console.error(err);
            if(err.code && err.code === "ERR_NETWORK"){
                showToast("error", f({id: 'error'}), err.message);
                return Promise.reject(err);
            }

            if(err.response.status === 401 && !err.config.url.includes('/login')){
                updateUserInfo({authenticated: false, roles: undefined, userId: undefined, username: undefined})
                return Promise.reject(err);
            }


            const priority = err.response.status >= 400 && err.response.status < 500 ? "warn" : "error";
            let message = err.response.status >= 400 && err.response.status < 500 ? err.response.data.message : "internalServerError";
            if(err.response.status === 401){
                message = 'wrongUsernameOrPassword'
            }
            else if(err.response.status === 400 && err.response.data && Array.isArray(err.response.data) && err.response.data.length > 0 && err.response.data[0].errorMessage !== undefined){
                message = <ul>
                    {
                        err.response.data.map((el : any, index: number) => <li key={index}>{el.errorMessage}</li>)
                    }
                </ul>
                showToast(priority, f({id: "operationUnsuccessful"}), message, true);
                return Promise.reject(err);
            }else if (err.response.status === 400 && err.response.data && err.response.data.errors && Object.values(err.response.data.errors).length > 0 ) {
                message = <ul>
                    {
                        Object.values(err.response.data.errors).map((el: any, index: number) => <li key={index}>{el}</li>)
                    }
                </ul>
                showToast(priority, f({id: "operationUnsuccessful"}), message, true);
                return Promise.reject(err);
            }
            const sticky = err.response.data.sticky;
            if(message !== undefined && message !== 'branchPrinterIpNotFound' && message !== 'pinRequired')
                showToast(priority, f({id: "operationUnsuccessful"}), f({id: message}), sticky);
            return Promise.reject(err);
        });

        return () => {
            axios.interceptors.response.eject(responseInterceptor);
        }
    }, []);

    return <>
        {props.children}
    </>
};
